import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { provideTranslocoScope, TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'idl-has-highlights',
  imports: [
    MatIconModule,
    MatTooltip,
    TranslocoPipe,
  ],
  templateUrl: './has-highlights.component.html',
  styleUrl: './has-highlights.component.scss',
  providers: [provideTranslocoScope('sharedInputs')]
})
export class HasHighlightsComponent {
  hasHighlights = input();
}
